// extracted by css-extract-rspack-plugin
export default {"root":"root-JSJao","number":"number-DQHoG","message":"message-3Y7ht"};